
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
export const EKG = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: true,
      };
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        className: 'non-dot-exam-scrollable',
        style: {
            position: "sticky",
            top: "0",
            zIndex: "1",
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            overflowX: "hidden"
        },
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails,
            },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
           },
           {
            type: "ResultSummary",
            results: [
                {
                    normalMsg: '',
                    abnormalMsg: '',
                    label: 'Patient',
                    data: [
                        { label: 'Blood Pressure', keyVal: 'blood_pressure_result'},
                        { label: 'EKG Findings', keyVal: 'ekg_findings_result'},
                    ],
                },
            ]
          },
           
    
    ],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'test_details',
                label:'Test Details',
                data:[
                    {
                        label:'Test Details',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                label:'Report Date',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Date',
                                placeholder:"Report Date",
                                name:'report_date_time',
                                id:'report_date_time',
                            },
                            {
                                label:'Technician',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'TextInput',
                                placeholder:"Technician",
                                name:'technician_name',
                                id:'technician_name',
                                
                            },
                            {
                                label:'Reviewed by',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'TextInput',
                                placeholder:"Reviewed by",
                                name:'reviewed_by',
                                id:'reviewed_by',
                            },
                            {
                                label:'Reviewed Date',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Date',
                                placeholder:"Reviewed Date",
                                name:'reviewed_date',
                                id:'reviewed_date',
                            },
                        ]
                    },
                    {
                        label:'Demographics',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                label:'Age',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Number',
                                placeholder:"Age",
                                name:'age',
                                id:'age',
                                max:3,
                            },
                            {
                                label:'Gender',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'SelectList',
                                placeholder:"Gender",
                                name:'gender',
                                id:'gender',
                                options:optionsToKeyValuePairs(['Female','Male','Unknown']),
                            },
                            {
                                label:'Height(In)',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Number',
                                placeholder:"Height",
                                name:'height_inches',
                                id:'height_inches',
                                max:1,
                            },
                            {
                                label:'Weight(Pounds)',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Number',
                                placeholder:"Weight",
                                name:'weight_pounds',
                                id:'weight_pounds',
                                max:3,
                            },
                        ]
                    },
                    {
                        label:'Blood Pressure / Ventricular Rate ',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                label:'Blood Pressure (mmHG)',
                                ...stackedFieldStyle,
                                col: 'col-4 border-0 ',
                                type:'Number',
                                placeholder:"Blood Pressure (mmHG)",
                                name:'blood_pressure_mmhg',
                                id:'blood_pressure_mmhg',
                                max:3,
                            },
                            {
                                label:'Ventricular Rate (BPM)',
                                ...stackedFieldStyle,
                                col: 'col-4 border-0 ',
                                type:'Number',
                                placeholder:"Ventricular Rate (BPM)",
                                name:'ventricular_rate_bpm',
                                id:'ventricular_rate_bpm',
                                max:3,
                            },
                        ]
                    },
                    {
                        label:'Intervals',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                label:'P (Msec)',
                                ...stackedFieldStyle,
                                col: 'col-2 border-0 ',
                                type:'Number',
                                placeholder:"P(msec)",
                                name:'p_msec',
                                id:'p_msec',
                                max:3,
                            },
                            {
                                label:'PR (msec)',
                                ...stackedFieldStyle,
                                col: 'col-2 border-0 ',
                                type:'Number',
                                placeholder:"PR (msec)",
                                name:'pr_msec',
                                id:'pr_msec',
                                max:3,
                            },
                            {
                                label:'RR (msec)',
                                ...stackedFieldStyle,
                                col: 'col-2 border-0 ',
                                type:'Number',
                                placeholder:"RR (msec)",
                                name:'rr_msec',
                                id:'rr_msec',
                                max:3,
                            },
                            {
                                label:'PQR (msec)',
                                ...stackedFieldStyle,
                                col: 'col-2 border-0 ',
                                type:'Number',
                                placeholder:"PQR (msec)",
                                name:'pqr_msec',
                                id:'pqr_msec',
                                max:3,
                            },
                            {
                                label:'QT (msec)',
                                ...stackedFieldStyle,
                                col: 'col-2 border-0 ',
                                type:'Number',
                                placeholder:"QT (msec)",
                                name:'qt_msec',
                                id:'qt_msec',
                                max:3,
                            },
                            {
                                label:'QTc (msec)',
                                ...stackedFieldStyle,
                                col: 'col-2 border-0 ',
                                type:'Number',
                                placeholder:"QTc (msec)",
                                name:'qtc_msec',
                                id:'qtc_msec',
                                max:3,
                            },
                        ]
                    },
                    {
                        label:'Axis',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                label:'P (Msec)',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Number',
                                placeholder:"P(msec)",
                                name:'p_axis_msec',
                                id:'p_axis_msec',
                                max:3,
                            },
                            {
                                label:'QRS (msec)',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Number',
                                placeholder:"QRS (msec)",
                                name:'qrs_axis_msec',
                                id:'qrs_axis_msec',
                                max:3,
                            },
                            {
                                label:'T (msec)',
                                ...stackedFieldStyle,
                                col: 'col-3 border-0 ',
                                type:'Number',
                                placeholder:"T (msec)",
                                name:'t_axis_msec',
                                id:'t_axis_msec',
                                max:3,
                            },
                        ]
                    }, 
                    {
                        label:'Interpretation Summary',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                label:'Findings',
                                ...stackedFieldStyle,
                                col: 'col-6 border-0 ',
                                type:'SelectList',
                                placeholder:"Findings",
                                name:'findings',
                                id:'findings',
                                options: optionsToKeyValuePairs([
                                    'Normal / No acute abnormality',
                                    'Abnormal / Acute abnormality',
                                    'Fracture - undisplaced',
                                    'Fracture - displaced',
                                    'Dislocation',
                                    'Effusion',
                                    'Degenerative changes / arthritis',
                                    'Foreign body present',
                                    'Other (specify)'
                                ]),                           
                            },
                            {
                                label:'Comments',
                                ...stackedFieldStyle,
                                col: 'col-6 border-0 ',
                                type:'TextArea',
                                placeholder:"Comments",
                                name:'comments',
                                id:'comments',
                            },
                            {
                                label:'Attachment',
                                type:'DragDropFileUpload',
                                col: 'col-12 border-0 ',
                                name:'ekg_attachment',
                                id:'ekg_attachment',
                                accept:'*/*',
                            },
                        ]
                    },
        
                   {
                        label: 'Review / Completion',
                        labelStyle: 'fw-semibold',
                        fields: [
                                   {
                                       type: 'ProviderSignOff',
                                       col: 'col-12',
                                       fields: [
                                               { label: 'Signature PIN',placeholder:'Signature PIN', name: 'provider_pin', col: 'col-12' },
                                               { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                                               { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                                               // { label : "Suggested Result", disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                                               // Previous options:
                                               // { label : "Final Results", type: "SelectList", name: "status", col: "col-12",options:isSet(props.lookupsOptions['chartResult'],[]), statusBasedColor: true },
                                               // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']), statusBasedColor: true },
                                               // New standard options:
                                               { 
                                                 label : "Final Results", 
                                                 type: "SelectList", 
                                                 name: "status", 
                                                 col: "col-12",
                                                 options: optionsToKeyValuePairs(
                                                   [
                                                     "Not Started",
                                                     "Pending",
                                                     "Normal",
                                                     "Abnormal",
                                                     "Negative",
                                                     "Positive",
                                                     "Dispensed",
                                                     "Administered",
                                                     "Failed",
                                                     "Passed",
                                                     "Non-Negative",
                                                     "Cancelled",
                                                     "Inconclusive",
                                                   ],
                                                   false
                                                 ),
                                                 statusBasedColor: true 
                                               },
                                               { 
                                                 label : "Activity Status", 
                                                 type: "SelectList", 
                                                 name: "activity_status", 
                                                 col: "col-12", 
                                                 options: optionsToKeyValuePairs(
                                                   [
                                                     "Not Started",
                                                     "Pending",
                                                     "Pending Lab Confirmation",
                                                     "Pending MRO Confirmation",
                                                     "Ready for Review",
                                                     "Completed",
                                                     "Cancelled",
                                                   ],
                                                   false
                                                 ),
                                                 statusBasedColor: true 
                                               },
                                        ],
                                    },
                                 ],
                        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        blood_pressure_result:'Not Started',
        ekg_findings_result:'Not Started',
        };
    const headers = [];
    return {
        charts,
        defaultValue,
        headers,
        computationFunction: (formData,key) => ({
            ...computationRules(formData,key),
            ...computationRules1(formData,key),
        }),
    };
}
const computationRules = (formData,key)=>{
    let returnResult = {};
    
    // EKG Findings Result
    returnResult.ekg_findings_result = 'Not Started';
    if(formData.findings === 'Normal / No acute abnormality'){
        returnResult.ekg_findings_result = 'Normal';
    }else if(formData.findings === 'Abnormal / Acute abnormality'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Fracture - undisplaced'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Fracture - displaced'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Dislocation'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Effusion'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Degenerative changes / arthritis'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Foreign body present'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Other (specify)'){
        returnResult.ekg_findings_result = 'Abnormal';
    }
    
    // Blood Pressure Result
    const bloodPressure = isSet(formData.blood_pressure_mmhg, '');
    let bloodPressureResult = 'Not Started';
    if(bloodPressure === ''){
        bloodPressureResult = 'Not Started';
    }else if(bloodPressure < 0 || bloodPressure > 139){
        bloodPressureResult = 'Abnormal';
    }else{
        bloodPressureResult = 'Normal';
    }
    returnResult.blood_pressure_result = bloodPressureResult;
    
    return returnResult;
    

  
}